import { makeStyles } from '@material-ui/styles';
import { green } from '@material-ui/core/colors';

export const makeSnackbarStyles = makeStyles({
  snackbarContent: {
    backgroundColor: green[600],
  },
});
